import { Checkbox, Col, Row } from "antd";

import React, { useEffect, useState } from "react";
import { useBathrooms } from "./Bathrooms.hook";
import { useTheme } from "../../../Styles/ThemeHook";
import { IC_Collapse } from "shared-components/Components/Collapse/web";
import {
    bathrooms,
} from "../../../ViewFragments/SearchResults/Sider/TopBarFilters/options"
import ButtonGroup from "../ButtonGroup/web";
import { Switch } from "src/Components/Swicth/web";

export const Bathrooms = ({ collapsable = false, inputType = "checkbox", filterChanged, triggerApplyFilter = undefined }) => {
	const { theme } = useTheme();
	const {
		show,
		data: {	selectedValue = [], setSelectedValue, exactMode },
	} = useBathrooms();
	let filter = null;

	const [usingExactMode, setUsingExactMode] = useState(exactMode);

	useEffect(() => {
		if(!exactMode && typeof selectedValue === 'object' && selectedValue !== null && selectedValue.length > 0)  {
			handleChange(selectedValue[0]);
		}
	}, [exactMode])

	const handleChange = (value) => {
		if(value === null) {
			handleClearFilter();
			return;
		}
		if(typeof(value) !== 'object') {
			value = [value];
		}
		const selectedOptions = bathrooms.filter((option) => value.includes(option.value));
        const dataOptions = selectedOptions.map((option) => ({text: exactMode ? option.text : option.text.replace(/baños?/, 'o más baños'), value: option.value}));
        
		handleApplyFilter({ bathrooms: dataOptions });
	};

	const handleClearFilter = () => {
        handleApplyFilter({ bathrooms: [], bathroomsExactMode: {text: null, value: false} });
    }

	const handleExactChange = (value) => {
		setUsingExactMode(value);
		handleApplyFilter({ bathroomsExactMode: {text: null, value} })

		if (!value) {
			setSelectedValue([]);
			handleClearFilter();
		};
	}

	const handleApplyFilter = (filter) => {
        if (triggerApplyFilter) triggerApplyFilter(filter);
        else filterChanged(filter)
    }

	if (!show) return null;

	if (inputType === "checkbox") {
		filter = (
			<Checkbox.Group value={selectedValue} onChange={handleChange}>
				<Row gutter={[0, theme.spacing.lgSpacing]}>
					{bathrooms?.map(option => (
						<Col span={24} key={`key_${option.value}_bathrooms`}>
							<Checkbox value={option.value}>
								{option.text}
							</Checkbox>
						</Col>
					))}
				</Row>
			</Checkbox.Group>
		);
	} else {
		filter = (
			<>
				<div className="filter__scrollable-box">
					<ButtonGroup
						options={bathrooms.map(option => {return {text: option.smallText, value: option.value}})}
						selected={selectedValue}
						allowMuliple={usingExactMode}
						onChange={handleChange} 
						cleanFilter={handleClearFilter}
						optionForAny={{text: 'Todos', value: null}}
						exactMode={usingExactMode}
					/>
				</div>

				<div className="filter__exact-mode">
					<span>Número exacto de baños</span>
					<Switch checked={usingExactMode} onChange={handleExactChange} />
				</div>

				<hr style={{width:"100%", border:'none', borderTop:'1px solid rgba(0,0,0,.06)', margin:'24px 0'}} />
			</>
		);
	}

	const label = "Baños";

	return (
		<div className={"filter bathrooms-filter"}>
			{collapsable ?
				<IC_Collapse label={label} isActive={selectedValue?.length >= 1} startOpen={selectedValue?.length >= 1}>
					{filter}
				</IC_Collapse> :
				<>
					{inputType === "buttonGroup" && <h3 className="filter-title">{label}</h3>}
					{filter}
				</>
			}
		</div>
	);
};
